export const products = [
  {
    id: 1,
    slug: "model-e-store-banne-premier-prix",
    name: "Model E",
    subtitle: "Store banne premier prix",
    badge: "Garanti 12 ans",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/2605f81b0f2c05378928f77d700ebeecf65f8b6ea2e964327f514bdb6e6d6c5b.png",
    shortDescription: "Store banne premier prix, garanti 12 ans. Qualité professionnelle, fabriqué sur mesure en France dans notre usine de Gardanne (13).",
    description: "Store banne premier prix, garanti 12 ans. Qualité professionnelle, fabriqué sur mesure en France dans notre usine de Gardanne (13). Store et toile garantis 12 ans. Prix direct usine.",
    features: [
      "Aluminium Première Fusion",
      "Toile 100% acrylique",
      "Visserie Inox",
      "Fabriqué en France",
      "Prix direct usine",
      "Garanti 12 ans"
    ],
    priceFrom: "À partir de 690€",
    category: "store-banne"
  },
  {
    id: 2,
    slug: "model-m-store-banne-monobloc",
    name: "Model M",
    subtitle: "Store banne monobloc",
    badge: "Garanti 12 ans",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/43712e43cae5ed607144c6c097c5a3285cdc667c57ecf7a7470753f8ed8aa3e2.png",
    shortDescription: "Store banne monobloc de qualité professionnelle. Livré réglé et prêt à poser. Fabriqué sur mesure en France dans notre usine de Gardanne (13).",
    description: "MODEL M est un store banne monobloc de qualité professionnelle. Il est livré réglé et prêt à poser. Il est fabriqué sur mesure en France dans notre usine de Gardanne (13). Store et toile sont garantis 12 ans. Prix direct usine.",
    features: [
      "Monobloc prêt à poser",
      "Aluminium Première Fusion",
      "Toile 100% acrylique",
      "Motorisation Somfy disponible",
      "Fabriqué en France",
      "Garanti 12 ans"
    ],
    priceFrom: "À partir de 890€",
    category: "store-banne"
  },
  {
    id: 3,
    slug: "model-v-store-veranda",
    name: "Model V",
    subtitle: "Store de véranda",
    badge: "Sur mesure",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/0c95985a2741a356744e66d29b38890e8852ba15f4231cd45eba4ed8a803e8cd.png",
    shortDescription: "Store coffre spécial véranda destiné à être installé sur des vérandas existantes. Seule solution véritablement efficace pour se protéger de la chaleur.",
    description: "MODEL V – Store coffre spécial véranda destiné à être installé sur des vérandas existantes. Ce store constitue la seule solution véritablement efficace pour se protéger de la chaleur dans une véranda. Il fonctionne parfaitement à plat ou avec n'importe quelle inclinaison. Fabriqué à la demande selon vos spécifications, et sur mesure. Montage très facile. Le store arrive entièrement assemblé et réglé.",
    features: [
      "Spécial véranda",
      "Fonctionne à plat ou incliné",
      "Entièrement assemblé et réglé",
      "Sur mesure",
      "Montage facile",
      "Fabriqué en France"
    ],
    priceFrom: "À partir de 1 290€",
    category: "store-veranda"
  },
  {
    id: 5,
    slug: "model-i-store-projection",
    name: "Model I",
    subtitle: "Store à projection",
    badge: "Sur mesure",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/3c579bf514783e0ee4a20f0e4043a94ed61b421028968a60dfedd65e109ee900.png",
    shortDescription: "Store à projection de grandes dimensions. Fabriqué à la demande selon vos spécifications sur mesure. Livré entièrement assemblé et réglé.",
    description: "Store à projection de grandes dimensions. Fabriqué à la demande selon vos spécifications sur mesure. Montage très facile. Nous vous livrons le store entièrement assemblé et réglé.",
    features: [
      "Grandes dimensions",
      "Entièrement assemblé et réglé",
      "Sur mesure",
      "Montage facile",
      "Aluminium Première Fusion",
      "Fabriqué en France"
    ],
    priceFrom: "À partir de 1 190€",
    category: "store-projection"
  },
  {
    id: 6,
    slug: "model-c-store-banne-coffre",
    name: "Model C",
    subtitle: "Store banne coffre",
    badge: "Garanti 12 ans",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/1c8021ad7ffa61575156ea1236fc8ae44f7f8ba0764128cabd3a5d50fc46047b.png",
    shortDescription: "Magnifique store coffre de grande dimensions. Éclairage LED intégré. Toile et armature parfaitement protégées des intempéries.",
    description: "Magnifique store coffre de grande dimensions. Éclairage LED intégré. La toile et l'armature sont parfaitement protégés des intempéries. Fabriqué à la demande selon vos spécifications, et sur mesure. Montage très facile. Le store arrive entièrement assemblé et réglé et s'installe comme un store monobloc.",
    features: [
      "Éclairage LED intégré",
      "Coffre de protection",
      "Grandes dimensions",
      "Entièrement assemblé et réglé",
      "Sur mesure",
      "Garanti 12 ans"
    ],
    priceFrom: "À partir de 2 490€",
    category: "store-banne"
  },
  {
    id: 7,
    slug: "model-m-store-terrasse",
    name: "Model M",
    subtitle: "Store de terrasse",
    badge: "Garanti 12 ans",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/9c2afded90cde7076fd15a69acb0f50522b12a7fceaf80cdfad7b01796b62403.png",
    shortDescription: "Store à double pente très apprécié des CHR. Construction très robuste en aluminium première fusion. Posé au sol, vissé ou scellé.",
    description: "Store à double pente très apprécié des CHR. Construction très robuste en aluminium première fusion. Il peut être indifféremment posé au sol, vissé ou scellé. Fabriqué à la demande selon vos spécifications, et sur mesure. Montage très facile. Ce store est garanti 12 ans.",
    features: [
      "Double pente",
      "Pose au sol, vissé ou scellé",
      "Très robuste",
      "Sur mesure",
      "Aluminium Première Fusion",
      "Garanti 12 ans"
    ],
    priceFrom: "À partir de 2 190€",
    category: "store-terrasse"
  },
  {
    id: 8,
    slug: "model-ic-store-projection-coffre",
    name: "Model IC",
    subtitle: "Store à projection avec coffre",
    badge: "Garanti 12 ans",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/d8110ff5e1d9dd2054e54979d61a04ad8336242f238f6741c2f17b45e75aa1ac.png",
    shortDescription: "Store à projection protégé par un coffre. Montage très facile. Le store arrive entièrement assemblé et réglé. Sur mesure, garanti 12 ans.",
    description: "Store à projection protégé par un coffre. La toile est parfaitement protégée. Montage très facile. Le store arrive entièrement assemblé et réglé. Fabriqué à la demande selon vos spécifications, et sur mesure. Ce store est garanti 12 ans.",
    features: [
      "Coffre de protection",
      "Entièrement assemblé et réglé",
      "Sur mesure",
      "Montage facile",
      "Aluminium Première Fusion",
      "Garanti 12 ans"
    ],
    priceFrom: "À partir de 1 490€",
    category: "store-projection"
  }
];

export const heroSlides = [
  {
    id: 1,
    image: "/images/hero-1.jpg",
    title: "Stores Sur Mesure",
    subtitle: "Qualité Professionnelle",
    description: "Fabricant français de stores extérieurs depuis 1986. Garantis 12 ans. Prix direct usine.",
    cta: "Voir nos stores",
    link: "/nos-stores"
  },
  {
    id: 2,
    image: "/images/hero-0.jpg",
    title: "Stores Bannes",
    subtitle: "Qualité Professionnelle",
    description: "Fabricant français de stores extérieurs depuis 1986. Garantis 12 ans. Prix direct usine.",
    cta: "Découvrir nos stores",
    link: "/nos-stores"
  },
  {
    id: 3,
    image: "/images/hero-3.jpg",
    title: "Prix Direct Usine",
    subtitle: "Fabriqué en France",
    description: "Tous nos stores sont fabriqués dans notre usine de 2000m² à Gardanne (13).",
    cta: "Demander un devis",
    link: "/contact"
  }
];

export const services = [
  {
    id: 1,
    icon: "headset",
    title: "Service Après Vente",
    description: "Notre équipe SAV est disponible pour vous accompagner après votre achat.",
    image: "https://stores-shop.com/wp-content/uploads/2021/10/picto-100-satisfait-ou-rembourse.jpg",
    link: "/service-apres-vente"
  },
  {
    id: 2,
    icon: "wrench",
    title: "Service Pose",
    description: "Nous vous proposons un service de pose professionnel dans votre région.",
    image: "https://stores-shop.com/wp-content/uploads/2021/10/picto-service-pose.jpg",
    link: "/service-pose"
  },
  {
    id: 3,
    icon: "shield",
    title: "Garantie 12 ans",
    description: "La majorité de nos produits sont garantis 12 ans, preuve de notre qualité.",
    image: "https://stores-shop.com/wp-content/uploads/2021/10/garantie-12-ans.jpg",
    link: "/garantie"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Comment choisir son store banne ?",
    excerpt: "Guide complet pour choisir le bon store banne selon votre façade, votre exposition et votre budget.",
    date: "15 mars 2024",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/43712e43cae5ed607144c6c097c5a3285cdc667c57ecf7a7470753f8ed8aa3e2.png",
    category: "Conseils"
  },
  {
    id: 2,
    title: "Store de véranda : la solution idéale",
    excerpt: "Découvrez pourquoi le store de véranda est l'investissement idéal pour votre confort.",
    date: "8 février 2024",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/0c95985a2741a356744e66d29b38890e8852ba15f4231cd45eba4ed8a803e8cd.png",
    category: "Guides"
  },
  {
    id: 3,
    title: "Entretien de votre store banne",
    excerpt: "Tous nos conseils pour entretenir votre store banne et prolonger sa durée de vie.",
    date: "22 janvier 2024",
    image: "https://static.prod-images.emergentagent.com/jobs/aa14fbb4-228f-44c4-aa37-92a64eec7555/images/1c8021ad7ffa61575156ea1236fc8ae44f7f8ba0764128cabd3a5d50fc46047b.png",
    category: "Entretien"
  }
];

export const partners = [
  { name: "SOMFY", url: "https://www.somfy.fr/", logo: null },
  { name: "Llaza", url: "http://www.llazafrance.com/", logo: null },
  { name: "Dickson", url: "#", logo: null }
];

export const stats = [
  { value: "1986", label: "Année de création" },
  { value: "2000m²", label: "Usine de fabrication" },
  { value: "12 ans", label: "Garantie produit" },
  { value: "100%", label: "Fabriqué en France" }
];
